const mainSrc = {
  m_01: '/static/home/main/main_01.jpg',
}

const mainSideHSrc = {
  h_01: '/static/home/main/side/h/h_01.jpg',
}

const mainSideWSrc = {
  w_01: '/static/home/main/side/w/w_01.jpg',
}

const shortcutSrc = {
  shorcut_01: '/static/home/shortcut/shortcut_01.png',
  shorcut_02: '/static/home/shortcut/shortcut_02.png',
  shorcut_03: '/static/home/shortcut/shortcut_03.png',
  shorcut_04: '/static/home/shortcut/shortcut_04.png',
  shorcut_05: '/static/home/shortcut/shortcut_05.png',
  shorcut_06: '/static/home/shortcut/shortcut_06.png',
  shorcut_07: '/static/home/shortcut/shortcut_07.png',
  shorcut_08: '/static/home/shortcut/shortcut_08.png',
}

const storySrc = {
  s_01: '/static/home/story/story_01.jpg',
  s_02: '/static/home/story/story_02.jpg',
  s_03: '/static/home/story/story_03.jpg',
}

const categorySrc = {
  c_01: '/static/home/cate/cate_01.png',
  c_02: '/static/home/cate/cate_02.jpg',
  c_03: '/static/home/cate/cate_03.jpg',
  c_04: '/static/home/cate/cate_04.jpg',
  c_05: '/static/home/cate/cate_05.jpg',
  c_06: '/static/home/cate/cate_06.jpg',
  c_07: '/static/home/cate/cate_07.jpg',
  c_08: '/static/home/cate/cate_08.jpg',
  c_09: '/static/home/cate/cate_09.png',
  c_10: '/static/home/cate/cate_10.jpg',
  c_11: '/static/home/cate/cate_11.jpg',
  c_12: '/static/home/cate/cate_12.jpg',
  c_13: '/static/home/cate/cate_13.png',
  c_14: '/static/home/cate/cate_14.png',
  c_15: '/static/home/cate/cate_15.jpg',
}

const pictureSrc = {
  p_1: '/static/home/picture/p_1.jpg',
  p_2: '/static/home/picture/p_2.jpg',
  p_3: '/static/home/picture/p_3.jpg',
  p_4: '/static/home/picture/p_4.jpg',
  p_5: '/static/home/picture/p_5.jpg',
  p_6: '/static/home/picture/p_6.jpg',
  p_7: '/static/home/picture/p_7.jpg',
  p_8: '/static/home/picture/p_8.jpg',
}

export {
  mainSrc,
  mainSideHSrc,
  mainSideWSrc,
  shortcutSrc,
  storySrc,
  categorySrc,
  pictureSrc,
}
